// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AcceptMatchedLinesData,
  AcceptMatchedLinesErrors,
  AcceptMatchedLinesResponses,
  AddDiscussionCommentData,
  AddDiscussionCommentErrors,
  AddDiscussionCommentResponses,
  AddFeedbackCommentData,
  AddFeedbackCommentErrors,
  AddFeedbackCommentResponses,
  AddLineData,
  AddLineErrors,
  AddLineResponses,
  ApproveLearnedAliasData,
  ApproveLearnedAliasErrors,
  ApproveLearnedAliasResponses,
  ApproveLinePriceData,
  ApproveLinePriceErrors,
  ApproveLinePriceResponses,
  ApproveQuotationDraftData,
  ApproveQuotationDraftErrors,
  ApproveQuotationDraftResponses,
  ApproveTruthLearningData,
  ApproveTruthLearningErrors,
  ApproveTruthLearningResponses,
  AssignCaseData,
  AssignCaseErrors,
  AssignCaseResponses,
  BulkAssignCasesData,
  BulkAssignCasesErrors,
  BulkAssignCasesResponses,
  BulkSetCaseStatusData,
  BulkSetCaseStatusErrors,
  BulkSetCaseStatusResponses,
  CaptureFieldsData,
  CaptureFieldsErrors,
  CaptureFieldsResponses,
  ClassifyIntentData,
  ClassifyIntentErrors,
  ClassifyIntentResponses,
  ConfirmCaseCustomerData,
  ConfirmCaseCustomerErrors,
  ConfirmCaseCustomerResponses,
  CorrectLineData,
  CorrectLineErrors,
  CorrectLineResponses,
  CreateAnswerDraftData,
  CreateAnswerDraftErrors,
  CreateAnswerDraftResponses,
  CreateDiscussionData,
  CreateDiscussionErrors,
  CreateDiscussionResponses,
  CreateFeedbackData,
  CreateFeedbackErrors,
  CreateFeedbackResponses,
  CreateProcessMiningImportData,
  CreateProcessMiningImportErrors,
  CreateProcessMiningImportResponses,
  DecideDiscussionData,
  DecideDiscussionErrors,
  DecideDiscussionResponses,
  DecideLineData,
  DecideLineErrors,
  DecideLineResponses,
  DownloadCaseAttachmentData,
  DownloadCaseAttachmentErrors,
  DownloadCaseAttachmentResponses,
  DownloadProcessMiningReportData,
  DownloadProcessMiningReportErrors,
  DownloadProcessMiningReportResponses,
  ExportFeedbackData,
  ExportFeedbackErrors,
  ExportFeedbackEvalData,
  ExportFeedbackEvalErrors,
  ExportFeedbackEvalResponses,
  ExportFeedbackResponses,
  ExportMasterDataDefectsData,
  ExportMasterDataDefectsErrors,
  ExportMasterDataDefectsResponses,
  ExportProcessMiningCasesData,
  ExportProcessMiningCasesErrors,
  ExportProcessMiningCasesResponses,
  GetAnswerDraftData,
  GetAnswerDraftErrors,
  GetAnswerDraftResponses,
  GetAreasData,
  GetAreasResponses,
  GetAutonomyMetricsData,
  GetAutonomyMetricsErrors,
  GetAutonomyMetricsResponses,
  GetCaseAttachmentChildData,
  GetCaseAttachmentChildErrors,
  GetCaseAttachmentChildResponses,
  GetCaseByMessageData,
  GetCaseByMessageErrors,
  GetCaseByMessageResponses,
  GetCaseCrmMachinesData,
  GetCaseCrmMachinesErrors,
  GetCaseCrmMachinesResponses,
  GetCaseCustomerMemoryData,
  GetCaseCustomerMemoryErrors,
  GetCaseCustomerMemoryResponses,
  GetCaseData,
  GetCaseErrors,
  GetCaseInstalledBaseData,
  GetCaseInstalledBaseErrors,
  GetCaseInstalledBaseResponses,
  GetCaseMailData,
  GetCaseMailErrors,
  GetCaseMailResponses,
  GetCaseResponses,
  GetCaseTranslationData,
  GetCaseTranslationErrors,
  GetCaseTranslationResponses,
  GetClassificationAuditData,
  GetClassificationAuditErrors,
  GetClassificationAuditResponses,
  GetCostReportData,
  GetCostReportErrors,
  GetCostReportResponses,
  GetCostSummaryData,
  GetCostSummaryErrors,
  GetCostSummaryResponses,
  GetCustomerMatchingMetricsData,
  GetCustomerMatchingMetricsErrors,
  GetCustomerMatchingMetricsResponses,
  GetDataHealthData,
  GetDataHealthResponses,
  GetDiscussionData,
  GetDiscussionErrors,
  GetDiscussionResponses,
  GetEngineStatusData,
  GetEngineStatusResponses,
  GetEntityRulesData,
  GetEntityRulesErrors,
  GetEntityRulesResponses,
  GetEntityRuleTableData,
  GetEntityRuleTableErrors,
  GetEntityRuleTableResponses,
  GetExecutiveMetricsData,
  GetExecutiveMetricsErrors,
  GetExecutiveMetricsResponses,
  GetFeedbackData,
  GetFeedbackErrors,
  GetFeedbackResponses,
  GetFeedbackSummaryData,
  GetFeedbackSummaryErrors,
  GetFeedbackSummaryResponses,
  GetFeedbackUnreadCountData,
  GetFeedbackUnreadCountErrors,
  GetFeedbackUnreadCountResponses,
  GetFinopsAlertsData,
  GetFinopsAlertsErrors,
  GetFinopsAlertsResponses,
  GetFoDraftData,
  GetFoDraftErrors,
  GetFoDraftResponses,
  GetHealthData,
  GetHealthResponses,
  GetLearningStatsData,
  GetLearningStatsErrors,
  GetLearningStatsResponses,
  GetMarginThresholdsData,
  GetMarginThresholdsErrors,
  GetMarginThresholdsResponses,
  GetMeData,
  GetMeResponses,
  GetModelHealthData,
  GetModelHealthErrors,
  GetModelHealthResponses,
  GetMyAttentionData,
  GetMyAttentionErrors,
  GetMyAttentionResponses,
  GetOpsMetricsData,
  GetOpsMetricsErrors,
  GetOpsMetricsResponses,
  GetPilotExportData,
  GetPilotExportErrors,
  GetPilotExportResponses,
  GetPilotMetricsData,
  GetPilotMetricsErrors,
  GetPilotMetricsResponses,
  GetPlatformStatusData,
  GetPlatformStatusErrors,
  GetPlatformStatusResponses,
  GetProcessMiningAreasData,
  GetProcessMiningAreasErrors,
  GetProcessMiningAreasResponses,
  GetProcessMiningBaselineData,
  GetProcessMiningBaselineErrors,
  GetProcessMiningBaselineResponses,
  GetProcessMiningCaseData,
  GetProcessMiningCaseErrors,
  GetProcessMiningCaseResponses,
  GetProcessMiningFindingsData,
  GetProcessMiningFindingsErrors,
  GetProcessMiningFindingsResponses,
  GetProcessMiningMapData,
  GetProcessMiningMapErrors,
  GetProcessMiningMapResponses,
  GetProcessMiningReportStatusData,
  GetProcessMiningReportStatusErrors,
  GetProcessMiningReportStatusResponses,
  GetProcessMiningSummaryData,
  GetProcessMiningSummaryErrors,
  GetProcessMiningSummaryResponses,
  GetProcessMiningToolsData,
  GetProcessMiningToolsErrors,
  GetProcessMiningToolsResponses,
  GetProcessMiningValueData,
  GetProcessMiningValueErrors,
  GetProcessMiningValueResponses,
  GetQuotationApprovalData,
  GetQuotationApprovalErrors,
  GetQuotationApprovalResponses,
  GetRuleSetData,
  GetRuleSetErrors,
  GetRuleSetResponses,
  GetRunsReportData,
  GetRunsReportErrors,
  GetRunsReportResponses,
  GetSalesTruthInquiryData,
  GetSalesTruthInquiryErrors,
  GetSalesTruthInquiryResponses,
  GetSalesTruthSummaryData,
  GetSalesTruthSummaryErrors,
  GetSalesTruthSummaryResponses,
  GetTrainingProgressData,
  GetTrainingProgressErrors,
  GetTrainingProgressResponses,
  GetTrainingTeamData,
  GetTrainingTeamErrors,
  GetTrainingTeamResponses,
  GetUsageMetricsData,
  GetUsageMetricsErrors,
  GetUsageMetricsResponses,
  GetUsagePeopleData,
  GetUsagePeopleErrors,
  GetUsagePeopleResponses,
  GetWorkloadMetricsData,
  GetWorkloadMetricsErrors,
  GetWorkloadMetricsResponses,
  ListCaseEventsData,
  ListCaseEventsErrors,
  ListCaseEventsResponses,
  ListCaseFeedbackData,
  ListCaseFeedbackErrors,
  ListCaseFeedbackResponses,
  ListDiscussionsData,
  ListDiscussionsErrors,
  ListDiscussionsResponses,
  ListFeedbackData,
  ListFeedbackErrors,
  ListFeedbackResponses,
  ListLearnedProposalsData,
  ListLearnedProposalsErrors,
  ListLearnedProposalsResponses,
  ListMasterDataDefectsData,
  ListMasterDataDefectsErrors,
  ListMasterDataDefectsResponses,
  ListMyFeedbackData,
  ListMyFeedbackErrors,
  ListMyFeedbackResponses,
  ListProcessMiningAnchorsData,
  ListProcessMiningAnchorsErrors,
  ListProcessMiningAnchorsResponses,
  ListProcessMiningCasesData,
  ListProcessMiningCasesErrors,
  ListProcessMiningCasesResponses,
  ListProcessMiningRunsData,
  ListProcessMiningRunsErrors,
  ListProcessMiningRunsResponses,
  ListProcessMiningVariantsData,
  ListProcessMiningVariantsErrors,
  ListProcessMiningVariantsResponses,
  ListQueueData,
  ListQueueErrors,
  ListQueueResponses,
  ListSalesTruthInquiriesData,
  ListSalesTruthInquiriesErrors,
  ListSalesTruthInquiriesResponses,
  ListSalesTruthPeopleData,
  ListSalesTruthPeopleErrors,
  ListSalesTruthPeopleResponses,
  ListTruthLearningsData,
  ListTruthLearningsErrors,
  ListTruthLearningsResponses,
  LogoutData,
  LogoutResponses,
  LookAgainData,
  LookAgainErrors,
  LookAgainResponses,
  MarkFeedbackSeenData,
  MarkFeedbackSeenErrors,
  MarkFeedbackSeenResponses,
  MarkMasterDataDefectData,
  MarkMasterDataDefectErrors,
  MarkMasterDataDefectResponses,
  OverrideLineData,
  OverrideLineErrors,
  OverrideLineResponses,
  PreviewCaseAttachmentData,
  PreviewCaseAttachmentErrors,
  PreviewCaseAttachmentResponses,
  PreviewQuoteData,
  PreviewQuoteErrors,
  PreviewQuoteResponses,
  PutTrainingModuleData,
  PutTrainingModuleErrors,
  PutTrainingModuleResponses,
  PutTrainingStateData,
  PutTrainingStateErrors,
  PutTrainingStateResponses,
  RecordCaseActivityData,
  RecordCaseActivityErrors,
  RecordCaseActivityResponses,
  RecordCaseFeedbackData,
  RecordCaseFeedbackErrors,
  RecordCaseFeedbackResponses,
  RecordTrainingAttemptData,
  RecordTrainingAttemptErrors,
  RecordTrainingAttemptResponses,
  RecordUsageData,
  RecordUsageErrors,
  RecordUsageResponses,
  RejectProposalData,
  RejectProposalErrors,
  RejectProposalResponses,
  RemoveAddedLineData,
  RemoveAddedLineErrors,
  RemoveAddedLineResponses,
  RequestCaseMailRestoreData,
  RequestCaseMailRestoreErrors,
  RequestCaseMailRestoreResponses,
  ResetTrainingData,
  ResetTrainingErrors,
  ResetTrainingResponses,
  ResolveCustomerData,
  ResolveCustomerErrors,
  ResolveCustomerResponses,
  ResolveLineData,
  ResolveLineErrors,
  ResolveLineResponses,
  RetractLearnedAliasData,
  RetractLearnedAliasErrors,
  RetractLearnedAliasResponses,
  RetractTruthLearningData,
  RetractTruthLearningErrors,
  RetractTruthLearningResponses,
  SearchCaseCatalogueData,
  SearchCaseCatalogueErrors,
  SearchCaseCatalogueResponses,
  SearchCaseCustomersData,
  SearchCaseCustomersErrors,
  SearchCaseCustomersResponses,
  SetCaseStatusData,
  SetCaseStatusErrors,
  SetCaseStatusResponses,
  SetDecisionFrameData,
  SetDecisionFrameErrors,
  SetDecisionFrameResponses,
  SetLineQuantitiesData,
  SetLineQuantitiesErrors,
  SetLineQuantitiesResponses,
  SetTruthLearningMultiAccountData,
  SetTruthLearningMultiAccountErrors,
  SetTruthLearningMultiAccountResponses,
  TranslateCaseMailData,
  TranslateCaseMailErrors,
  TranslateCaseMailResponses,
  TriageFeedbackData,
  TriageFeedbackErrors,
  TriageFeedbackResponses,
  WithdrawQuotationApprovalData,
  WithdrawQuotationApprovalErrors,
  WithdrawQuotationApprovalResponses,
  WriteProcessMiningReportTextsData,
  WriteProcessMiningReportTextsErrors,
  WriteProcessMiningReportTextsResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Health
 *
 * Return a simple health status payload.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Resolve Line
 *
 * Resolve one enquiry line to a catalogue item — learned corrections first, then the ladder.
 *
 * APPLY-FIRST: before touching the engine, this checks the correction-learning store
 * for an ACTIVE learned alias matching (area, customer, line). A hit is returned
 * directly as a touchless match (ladder_level 0). That is a RECORDED HUMAN DECISION
 * legitimately overriding the ladder — not a candidates-from-tools violation, because
 * the item came from a reviewer's correction, not from an ungrounded model guess. If
 * the correction store is unconfigured/unreachable the lookup is swallowed and the
 * request falls through to the normal engine path (never a 503 from the lookup).
 *
 * The I2Q engine is imported lazily here (not at module top) so the app boots
 * without the engine's runtime dependencies — the local Postgres mirror,
 * Foundry credentials and embedding matrices. Those are wired in via the
 * ``RFQ_*`` environment variables (see ``.env.example``); when any is missing
 * the engine raises ``EngineNotConfiguredError`` and this returns a clean ``503``
 * rather than crashing the app. This is a deliberate, documented exception to
 * the "imports at top of file" convention.
 *
 * Per-area visibility: a learned alias is keyed by area and customer, not by mailbox,
 * so a hit can come from a correction made in another area. A caller without
 * ``Area.All`` gets the learned item and the ``learned_correction`` evidence kind, but
 * not the reviewer's e-mail address or the date of the correction.
 *
 * The requested area must be one the session holds (``Area.All`` holds every one):
 * another area is a 403, and so is a session without any area. The check runs first,
 * before the learned lookup and before the engine.
 *
 * Read-only: this path never writes to Go Autonomous, the mailboxes or F&O (the learned
 * lookup only READS the app DB).
 */
export const resolveLine = <ThrowOnError extends boolean = false>(
  options: Options<ResolveLineData, ThrowOnError>,
) =>
  (options.client ?? client).post<ResolveLineResponses, ResolveLineErrors, ThrowOnError>({
    url: "/resolve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Engine Status
 *
 * Report whether the I2Q engine's runtime sources are configured (booleans only).
 *
 * Always 200: it reports configuration rather than requiring it, so the frontend
 * can render a "not configured" state without a 503 handshake. Never returns a
 * secret — only whether the local Postgres mirror (``RFQ_DB_URL``) and the
 * Foundry chat/embed deployments resolve. Read-only.
 */
export const getEngineStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetEngineStatusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetEngineStatusResponses, unknown, ThrowOnError>({
    url: "/status",
    ...options,
  });

/**
 * Classify Mail Intent
 *
 * Classify one mail into one of the engine's seven business intents (read-only).
 *
 * The engine's ``classify_intent`` swallows every error and degrades to a
 * low-confidence ``general_other``, so this probes the Foundry chat config up
 * front and returns a clean 503 when the engine is unconfigured — otherwise an
 * unconfigured host would answer 200 with a meaningless verdict.
 */
export const classifyIntent = <ThrowOnError extends boolean = false>(
  options: Options<ClassifyIntentData, ThrowOnError>,
) =>
  (options.client ?? client).post<ClassifyIntentResponses, ClassifyIntentErrors, ThrowOnError>({
    url: "/intent/classify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Resolve Customer Identity
 *
 * Identify the customer behind an enquiry: header-first, then mail content (read-only).
 *
 * Backed by ``quote_agent.resolve_customer_content``, which queries the local
 * mirror (contact/domain tables) and falls back to an LLM identity read of the
 * signature / letterhead. The DB lookup raises ``EngineNotConfiguredError`` when
 * unwired; probing ``RFQ_DB_URL`` up front makes the 503 deterministic.
 *
 * The requested area must be one the session holds (403 otherwise, also for a session
 * without any area): the customer master of another legal entity is not looked up.
 */
export const resolveCustomer = <ThrowOnError extends boolean = false>(
  options: Options<ResolveCustomerData, ThrowOnError>,
) =>
  (options.client ?? client).post<ResolveCustomerResponses, ResolveCustomerErrors, ThrowOnError>({
    url: "/customer/resolve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Preview Quote
 *
 * Run the full read-only pipeline on one enquiry and return the glass-box draft.
 *
 * DRY-RUN ONLY. ``quote_enquiry`` assembles context, gates on intent, identifies
 * the customer, captures fields and resolves each line, then builds the F&O quote
 * payload and validates it with ``execute=False`` — it NEVER sends or writes to
 * Go Autonomous, the mailboxes or F&O. There is no ``execute=True`` path on this
 * surface; ``fo_submission.dry_run`` is the proof.
 *
 * ``quote_enquiry``'s intent gate swallows errors, so this probes DB + Foundry
 * config up front to keep the 503-unconfigured contract deterministic.
 *
 * RBAC: the draft carries commercial cost/margin internals per line. They are
 * masked server-side before serialization for every session without the capability
 * ``see_margin`` (rbac-concept §3, §5.4; ``rfq_foundry.api.rbac``): a rep sees the
 * price and the verdict chip, a manager sees the raw cost/contribution/threshold.
 * A role never widens the areas: the requested area must be one the session holds
 * (403 otherwise, also for a session without any area), manager or not.
 */
export const previewQuote = <ThrowOnError extends boolean = false>(
  options: Options<PreviewQuoteData, ThrowOnError>,
) =>
  (options.client ?? client).post<PreviewQuoteResponses, PreviewQuoteErrors, ThrowOnError>({
    url: "/quote/preview",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Capture Mail Fields
 *
 * Extract logistics/header fields from a raw MIME mail (read-only).
 *
 * Backed by ``field_capture.capture_from_mime``, which swallows LLM errors and
 * returns an empty result (with an ``error``); this probes the Foundry chat
 * config up front so an unconfigured host returns a clean 503 rather than a
 * misleading empty 200.
 */
export const captureFields = <ThrowOnError extends boolean = false>(
  options: Options<CaptureFieldsData, ThrowOnError>,
) =>
  (options.client ?? client).post<CaptureFieldsResponses, CaptureFieldsErrors, ThrowOnError>({
    url: "/fields/capture",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Data Health
 *
 * Whether the platform is working on live data right now (never 503).
 *
 * The backlog numbers and the newest received mail cover only the mailboxes of the
 * caller's areas; the health flags (database, mail import, master data) are global.
 * The master data of a new area (Mexico, Wheelabrator Germany, Czechia) is judged
 * once that area is live, and only for a caller who may see it.
 *
 * One health level (``ok`` / ``degraded`` / ``stale``) plus the issues behind it as
 * complete English sentences: a read-only database, a stalled mail import, stale
 * master data, a queue backlog. Reads the app DB over a short-lived connection with a
 * 3 s connect timeout; when the DB is unset or unreachable the answer is ``stale``
 * with the single issue ``store_unreachable``. Read-only.
 */
export const getDataHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetDataHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDataHealthResponses, unknown, ThrowOnError>({
    url: "/status/data",
    ...options,
  });

/**
 * List Areas
 *
 * The areas the caller may see, in display order (all nine for ``Area.All``).
 *
 * ``code`` is the legal entity and equals ``area`` on a case and the value of the
 * queue's ``area`` filter; ``role`` is the code of the Entra app role. ``live`` says
 * whether the catalogue of the area is live: until then the cases of its mailbox
 * carry no area. ``reply_source`` says whether the reps' sent documents of the area
 * are read. A session without an area gets an empty list. Read-only.
 */
export const getAreas = <ThrowOnError extends boolean = false>(
  options?: Options<GetAreasData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAreasResponses, unknown, ThrowOnError>({
    url: "/areas",
    ...options,
  });

/**
 * List Queue
 *
 * The triage queue: one filtered page of ingested cases plus the per-view counts.
 *
 * ``view`` picks the slice: ``work`` (default) is everything a person can act on
 * (inquiries in draft-ready or needs-review, including cases whose customer is not
 * identified yet; with ``exclude_replied=false`` also the replied inquiries), ``ready``,
 * ``review``, ``unidentified`` (customer not identified), ``not-rfq``, ``parked``
 * (purchase orders: classified and counted, outside the scope of Norican I2Q, never in
 * any other view), ``waiting`` (queued or processing), ``all`` (every case except
 * copies and parked orders) and ``portal`` (open portal and tender notices, sim360 P32;
 * they also stay in ``work`` unless the switch ``autonomy_file_portal_notices`` is ON).
 * ``counts`` are the per-view totals under the same filters with the view condition
 * removed, so the tabs can show them. By default mails from
 * Norican senders and mails from mailboxes without an area are hidden.
 *
 * ``work``, ``ready``, ``review`` and ``unidentified`` hold only cases that are still
 * open. A case sales answered is in ``replied``, one set to wait for the customer
 * is in ``waiting-customer``, and one that is done (marked by sales, or a quotation
 * was sent) is in ``closed``. ``assignee`` narrows every view and count to the
 * caller's own cases, to unassigned ones, or to both; ``me`` is always the signed-in
 * user.
 *
 * Per-area visibility: rows, ``total`` and ``counts`` cover only the mailboxes of the
 * caller's areas. ``mailbox`` can narrow within those, never widen. The same holds
 * for ``customer_role`` (the role the engine stored for the sender, for example
 * ``sister_company`` for a Norican group company that is buying): it only narrows.
 *
 * Sales experience: ``backlog`` counts the open inquiries under the same filters but
 * without the received-date range (what the date filter hides). Every row carries the
 * read-time hints: suggested customers, a stored reply draft, the colleague who
 * forwarded the mail, the folded replies, why it needs the caller now, the working
 * days it is open and a close hint. A close hint changes the filing only while its
 * autonomy switch is ON (``store.autonomy_switch``, all OFF by default).
 *
 * Reads the app DB (``DATABASE_URL``) only; it is read-only over every external
 * system (mailboxes, Go Autonomous, F&O). Returns a clean 503 when the case store
 * is unconfigured/unreachable.
 */
export const listQueue = <ThrowOnError extends boolean = false>(
  options?: Options<ListQueueData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListQueueResponses, ListQueueErrors, ThrowOnError>({
    url: "/queue",
    ...options,
  });

/**
 * Get Case By Message
 *
 * The stored case for an open mail, looked up by its RFC ``internetMessageId``.
 *
 * The Outlook add-in path: the -GA intake copy and the base-mailbox copy carry the
 * same ``internetMessageId``, so a rep opening the mail in either finds the case.
 * Same masking as ``/cases/{id}``; 404 when no case exists or the case is outside the
 * caller's areas (the add-in then falls back to its live preview), 503 when the store
 * is unconfigured.
 */
export const getCaseByMessage = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseByMessageData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCaseByMessageResponses, GetCaseByMessageErrors, ThrowOnError>({
    url: "/cases/by-message",
    ...options,
  });

/**
 * Get Case
 *
 * One full case for the 3-pane review, from the LOCAL case store.
 *
 * Reconstructs the glass-box detail from the persisted enquiry + draft. Read-only
 * over every external system; ``fo_submission`` in the detail is the stored dry run
 * (``dry_run=True``), the proof the write path never fired. 404 when the id is
 * unknown or the case is outside the caller's areas (the two are indistinguishable),
 * 503 when the store is unconfigured.
 *
 * RBAC: the case's lines carry commercial cost/margin internals, masked
 * server-side before serialization unless the session holds ``see_margin``
 * (rbac-concept §3; ``rfq_foundry.api.rbac``), same mask as ``/quote/preview``.
 */
export const getCase = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCaseResponses, GetCaseErrors, ThrowOnError>({
    url: "/cases/{case_id}",
    ...options,
  });

/**
 * Get Case Mail
 *
 * The stored source mail of a case: headers, a plain-text body, the attachment list.
 *
 * The body is always plain text (an HTML-only mail is converted server-side; no
 * markup is ever returned), capped at 200000 characters. ``available`` is false
 * while the mail body is not stored yet (the case is queued or processing).
 * ``body_source`` is ``too_large`` when the stored mail exceeds 25 MB. Reads the app
 * DB only; nothing is fetched from a mailbox. 404 for an unknown id and for a case
 * outside the caller's areas.
 */
export const getCaseMail = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseMailData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCaseMailResponses, GetCaseMailErrors, ThrowOnError>({
    url: "/cases/{case_id}/mail",
    ...options,
  });

/**
 * Request Case Mail Restore
 *
 * Ask I2Q to fetch a removed original mail again from the mailbox.
 *
 * Only marks the case in the app DB; the mail-ingest job reads the original back with a
 * Graph GET within a few minutes and keeps it only when it is byte for byte the mail
 * that was removed. Nothing in the mailbox is changed. Answers the mail view with
 * ``restore = requested``. 404 outside the caller's areas, 409 when the original is
 * stored (or was never stored).
 *
 * sim360 P17: a case the engine failed on whose mail was never stored
 * (``can_fetch_again``) is queued for the engine again instead; the ingest then reads
 * the mail from the mailbox (a Graph GET) as for a new mail.
 */
export const requestCaseMailRestore = <ThrowOnError extends boolean = false>(
  options: Options<RequestCaseMailRestoreData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RequestCaseMailRestoreResponses,
    RequestCaseMailRestoreErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/mail/restore", ...options });

/**
 * Download Case Attachment
 *
 * Download one attachment of the stored mail (``index`` from ``/cases/{id}/mail``).
 *
 * Always ``Content-Disposition: attachment`` and ``X-Content-Type-Options: nosniff``.
 * The content type comes from a fixed allow-list (PDF, PNG, JPEG, GIF, plain text,
 * CSV, Excel, Word); anything else is ``application/octet-stream``, so an HTML or
 * SVG attachment can never render in the browser. 404 for a case outside the caller's
 * areas, exactly like an unknown case.
 */
export const downloadCaseAttachment = <ThrowOnError extends boolean = false>(
  options: Options<DownloadCaseAttachmentData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    DownloadCaseAttachmentResponses,
    DownloadCaseAttachmentErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/attachments/{index}", ...options });

/**
 * Get Case Attachment Child
 *
 * Download one file inside an attachment: an attached mail or an Office file (H-17).
 *
 * ``child`` is ``source.child`` of a draft line and ``child`` of an ``attachments_read``
 * entry (decision 1 of 14 Oct 2026: pictures in forwarded mails and in Office files are
 * read). The same access rule and headers as ``GET /cases/{case_id}/attachments/{index}``:
 * always ``Content-Disposition: attachment``, ``nosniff``, a content type from the fixed
 * allow-list; 404 for a case outside the caller's areas. Read-only.
 */
export const getCaseAttachmentChild = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseAttachmentChildData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCaseAttachmentChildResponses,
    GetCaseAttachmentChildErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/attachments/{index}/children/{child}", ...options });

/**
 * Preview Case Attachment
 *
 * A preview of a picture (or a scanned page) the engine read: whole, or one part.
 *
 * Rendered on request from the stored mail in the isolated attachment worker,
 * re-encoded (no EXIF, no GPS), never stored: ``Cache-Control: private, no-store``. Only
 * for an attachment whose stored reading is a picture (``photo``) or a page read as an
 * image. 409 when the reading says people are visible. 404 for a case outside the
 * caller's areas, exactly like an unknown case.
 */
export const previewCaseAttachment = <ThrowOnError extends boolean = false>(
  options: Options<PreviewCaseAttachmentData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PreviewCaseAttachmentResponses,
    PreviewCaseAttachmentErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/attachments/{index}/preview", ...options });

/**
 * Get Ops Metrics
 *
 * The live operations dashboard from the app DB (case store, outcomes, ingest, sync).
 *
 * Volume per area/day, inquiry share, draft-ready / needs-review split, agreement with
 * the rep's sent reply, ingest health, mirror data age and the egress gate state.
 * ``generated_at`` is when the figures were computed (served from a cache for up to 5
 * minutes; see ``ingest`` and ``data_freshness`` for the age of the data). With
 * ``weeks`` the window is that many completed calendar weeks (Monday to Sunday, UTC)
 * ending with the week of ``end`` (default: the last completed week), the same period
 * the executive summary counts; ``days`` is then ignored. Contains no cost/margin
 * figures. 503 when the store is unconfigured/unreachable.
 *
 * Per-area visibility: every case-derived number (tiles, per-area table, volume
 * series, outcomes, backlog) and the mailbox list cover only the mailboxes of the
 * caller's areas. The import run times, master-data freshness and egress gate are
 * platform health and stay global.
 */
export const getOpsMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<GetOpsMetricsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetOpsMetricsResponses, GetOpsMetricsErrors, ThrowOnError>({
    url: "/metrics/ops",
    ...options,
  });

/**
 * Get Cost Report
 *
 * The metered model cost: today, this week, this month, 30 days, forecast and caps.
 *
 * Every model call of I2Q is recorded with its tokens, never its text
 * (``rfq_model_call``); cost = tokens x list price (``finops/prices.yaml``), the Azure
 * invoice is the authority. By deployment, step (purpose), reason (run kind) and
 * entity; cost per case of new mail per entity (median, 9 in 10); the 20 most
 * expensive cases of the month and why; the caps and how much of each is used; the
 * Azure cost and budget when the cost reader is connected. Totals are platform
 * figures; the entity figures cover the caller's areas (an admin: every entity); a case
 * id outside the caller's areas is ``null``. Admins only (``see_finops``). Cached 5
 * minutes.
 */
export const getCostReport = <ThrowOnError extends boolean = false>(
  options?: Options<GetCostReportData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCostReportResponses, GetCostReportErrors, ThrowOnError>({
    url: "/metrics/cost",
    ...options,
  });

/**
 * Get Cost Summary
 *
 * The model cost of the month: month to date, forecast, budget, trend.
 *
 * No case, no entity: platform figures only. Admins only (``see_finops``); "What runs
 * today" reads the same cached figures without this route. Cached 5 minutes.
 */
export const getCostSummary = <ThrowOnError extends boolean = false>(
  options?: Options<GetCostSummaryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCostSummaryResponses, GetCostSummaryErrors, ThrowOnError>({
    url: "/metrics/cost/summary",
    ...options,
  });

/**
 * Get Runs Report
 *
 * The mail import runs, the re-read of stored mail, the data jobs and the queue.
 *
 * Runs of the window (duration, cases, errors, metered cost), the re-read plan of the
 * newest run (size, estimated cost, days at the cap, paused), the data jobs (master
 * data, OmniAnalytics, CRM, search index), the queue by state of the caller's areas,
 * calls and failures per step, engine errors of 7 days by kind (never the text) and the
 * slowest cases. Admins only (``see_finops``). Cached 5 minutes.
 */
export const getRunsReport = <ThrowOnError extends boolean = false>(
  options?: Options<GetRunsReportData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetRunsReportResponses, GetRunsReportErrors, ThrowOnError>({
    url: "/metrics/runs",
    ...options,
  });

/**
 * Get Model Health
 *
 * How the models reply: calls, errors, throttling, content filter, time-outs, latency.
 *
 * Per deployment, and per deployment and step, from the metered calls of the window.
 * Platform figures. Admins only (``see_finops``). Cached 60 seconds.
 */
export const getModelHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetModelHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetModelHealthResponses, GetModelHealthErrors, ThrowOnError>({
    url: "/metrics/model-health",
    ...options,
  });

/**
 * Get Finops Alerts
 *
 * What fired: the app's caps and alert levels, and the Azure alerts when readable.
 *
 * Admins only (``see_finops``). Cached 5 minutes.
 */
export const getFinopsAlerts = <ThrowOnError extends boolean = false>(
  options?: Options<GetFinopsAlertsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFinopsAlertsResponses, GetFinopsAlertsErrors, ThrowOnError>({
    url: "/metrics/alerts",
    ...options,
  });

/**
 * Correct Line
 *
 * Record a reviewer's correction of one resolved line — the seed of the learning flywheel.
 *
 * The line's context (area, customer, enquiry text, the engine's pick) is read from the
 * stored case/line. Only an ``Area.All`` caller may supply it in the request body instead
 * (for a case or line that is not stored). The reviewer is the verified session identity,
 * never the body. For an
 * ``item`` verdict this learns an EXACT (active) alias and a BROAD (proposed) alias; the
 * broad tier only starts matching after ``POST /learned/{alias_id}/approve``.
 *
 * Per-area visibility: a caller without ``Area.All`` can only correct a stored line of
 * a stored case from one of their mailboxes. Any other case id or line index is a 404,
 * a case without an area is a 422, and the context fields of the request body are
 * ignored. ``Area.All`` keeps the body fallback for a case that is not stored.
 *
 * Local write: only the app DB is written; nothing reaches Go Autonomous, a mailbox or F&O.
 */
export const correctLine = <ThrowOnError extends boolean = false>(
  options: Options<CorrectLineData, ThrowOnError>,
) =>
  (options.client ?? client).post<CorrectLineResponses, CorrectLineErrors, ThrowOnError>({
    url: "/cases/{case_id}/lines/{line_index}/correct",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Decide Line
 *
 * Confirm the engine's item for a line, pick another item, say "no item", or undo.
 *
 * ``line_key`` must be the key of the stored line at ``line_index`` (409
 * ``line_changed`` otherwise: the case was evaluated again). A picked item must exist
 * in the catalogue of ``item_area`` (default: the area of the case); an unknown item
 * is a 422, and when the catalogue cannot be read nothing is stored (503). The
 * decision is also written to the correction log (confirm, item, abstain), so there is
 * one audit trail. The first decision on an unassigned case assigns it to the caller.
 */
export const decideLine = <ThrowOnError extends boolean = false>(
  options: Options<DecideLineData, ThrowOnError>,
) =>
  (options.client ?? client).post<DecideLineResponses, DecideLineErrors, ThrowOnError>({
    url: "/cases/{case_id}/lines/{line_index}/decision",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Override Line
 *
 * Correct a line read by the engine: reviewed quantity and/or unit, take it out, undo.
 *
 * Same contract as a line decision: ``line_key`` must be the key of the stored line at
 * ``line_index`` (409 ``line_changed`` otherwise), ``expected_version`` the work version
 * the caller saw (409 with the current work row otherwise), the case inside the caller's
 * areas (404 otherwise) and not a parked order (422). ``edit`` replaces an earlier
 * correction of the line; ``remove`` takes the line out of prices, checks, the quotation
 * preview and the reply; ``clear`` takes the correction back. The engine's own values stay
 * stored and are shown next to the reviewed ones. Every write is one audited event;
 * prices, checks and the reply follow on the next read, and a reply prepared earlier is
 * for an older version of the case. Only the app DB is written.
 */
export const overrideLine = <ThrowOnError extends boolean = false>(
  options: Options<OverrideLineData, ThrowOnError>,
) =>
  (options.client ?? client).post<OverrideLineResponses, OverrideLineErrors, ThrowOnError>({
    url: "/cases/{case_id}/lines/{line_index}/override",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add Line
 *
 * Add a line the engine missed (or change one sales added, with its ``line_key``).
 *
 * The text and a whole quantity are required; a unit and a catalogue item are optional.
 * An item must exist in the catalogue of ``item_area`` (default: the area of the case;
 * 422 for an unknown item or a case without an area, 503 when the catalogue cannot be
 * read, nothing stored then). Versioned, scoped and audited like a line decision.
 */
export const addLine = <ThrowOnError extends boolean = false>(
  options: Options<AddLineData, ThrowOnError>,
) =>
  (options.client ?? client).post<AddLineResponses, AddLineErrors, ThrowOnError>({
    url: "/cases/{case_id}/lines/add",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove Added Line
 *
 * Delete a line sales added (404 for a key that is not an added line of this case).
 */
export const removeAddedLine = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAddedLineData, ThrowOnError>,
) =>
  (options.client ?? client).post<RemoveAddedLineResponses, RemoveAddedLineErrors, ThrowOnError>({
    url: "/cases/{case_id}/lines/added/remove",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Line Quantities
 *
 * Set one reviewed quantity on several lines of a case in ONE write, or take them off.
 *
 * ``set``: the whole quantity ``qty`` (and ``unit`` when given) becomes the reviewed
 * quantity of every named line that I2Q read, as an ``edit`` correction; a manual price
 * of a line stays. ``restore``: the reviewed quantity and unit of every named line are
 * taken off, so what I2Q read counts again; a manual price stays, and a correction left
 * empty is removed. A key the case does not hold, a stand-in line, a line taken out and
 * (for ``restore``) a line without a reviewed quantity are skipped with a reason.
 *
 * One write: one version step and one history entry, and the first write takes the
 * case. When nothing changes, nothing is written and the version stays. 409 on a stale
 * version, 422 for a parked order or a case that is not open, 404 outside the caller's
 * areas. Only the app DB is written; nothing is sent and nothing reaches F&O.
 */
export const setLineQuantities = <ThrowOnError extends boolean = false>(
  options: Options<SetLineQuantitiesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SetLineQuantitiesResponses,
    SetLineQuantitiesErrors,
    ThrowOnError
  >({
    url: "/cases/{case_id}/lines/quantity",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Case Status
 *
 * Mark a case done, not for us or waiting for the customer; ``open`` reopens it.
 *
 * A reopen is sticky: replies sent before it no longer count as an answer. The first
 * status on an unassigned case assigns it to the caller.
 *
 * Reopening a case that a COLLEAGUE marked done, not for us or waiting needs the
 * capability ``reopen_others`` (a manager): without it the answer is 403
 * ``reopen_needs_manager``. On a case a colleague CLOSED (done, not for us) that holds
 * for every status change, not only for ``open``, so the case cannot be moved to
 * another status first and reopened then. Reopening your own case stays allowed, and
 * so does setting a status on a case a colleague marked waiting. The case must be
 * inside the caller's areas first (404 otherwise, whatever the role).
 */
export const setCaseStatus = <ThrowOnError extends boolean = false>(
  options: Options<SetCaseStatusData, ThrowOnError>,
) =>
  (options.client ?? client).post<SetCaseStatusResponses, SetCaseStatusErrors, ThrowOnError>({
    url: "/cases/{case_id}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Assign Case
 *
 * Take a case, take it over from a colleague, or release it.
 *
 * ``take`` on a case a colleague holds is refused with 409 ``assigned_to_other``;
 * ``take_over`` is the explicit way, and its history entry names the colleague.
 */
export const assignCase = <ThrowOnError extends boolean = false>(
  options: Options<AssignCaseData, ThrowOnError>,
) =>
  (options.client ?? client).post<AssignCaseResponses, AssignCaseErrors, ThrowOnError>({
    url: "/cases/{case_id}/assign",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confirm Case Customer
 *
 * Confirm the customer account of a case (``null`` takes the confirmation back).
 *
 * The account must exist in the legal entity of the case (422 otherwise, also for a
 * case without a legal entity; 503 when master data cannot be read). The case then
 * goes back to the engine, which evaluates it again with that customer.
 */
export const confirmCaseCustomer = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmCaseCustomerData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ConfirmCaseCustomerResponses,
    ConfirmCaseCustomerErrors,
    ThrowOnError
  >({
    url: "/cases/{case_id}/customer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Look Again
 *
 * Ask the deeper search to look at the case again, or at one line (``line_key``).
 *
 * The request is one history entry, and the case goes back to the engine. The engine
 * evaluates it again with the same budget and every guard; the result arrives on the
 * case page as proposals for a person. A line that a person decided is not looked at
 * again: 422 "Clear the decision first." 422 also when "Look again" is not offered for
 * the case (the switch ``RFQ_MATCHING_INVESTIGATION_ON_DEMAND`` does not name its legal
 * entity, the case is closed, parked or has no finished draft). 409 ``look_again_pending``
 * while an earlier request still waits, 409 on a stale version, 404 outside the
 * caller's areas. A case has a limit, because each request is a full evaluation: 422
 * after 3 requests for the case, and 422 for a request less than 2 minutes after the
 * one before (``store.work.look_again_limit``).
 */
export const lookAgain = <ThrowOnError extends boolean = false>(
  options: Options<LookAgainData, ThrowOnError>,
) =>
  (options.client ?? client).post<LookAgainResponses, LookAgainErrors, ThrowOnError>({
    url: "/cases/{case_id}/investigation/look-again",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reject Proposal
 *
 * Reject one proposal of the deeper search ("Not this one").
 *
 * ``proposal_id`` must be a proposal that the stored draft of the case shows (404
 * otherwise). The history entry is filled from the stored draft, never from the
 * request. Nothing is evaluated again and no line or customer changes. With the switch
 * ``RFQ_MATCHING_INVESTIGATION_LEARN_NEGATIVES`` on, the engine does not propose the
 * same account first again for this sender, nor the same item for the same written
 * number. 409 on a stale version, 422 for a parked order, 404 outside the caller's areas.
 */
export const rejectProposal = <ThrowOnError extends boolean = false>(
  options: Options<RejectProposalData, ThrowOnError>,
) =>
  (options.client ?? client).post<RejectProposalResponses, RejectProposalErrors, ThrowOnError>({
    url: "/cases/{case_id}/investigation/reject",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Case Events
 *
 * The last 50 things people did with a case, newest first, as plain sentences.
 */
export const listCaseEvents = <ThrowOnError extends boolean = false>(
  options: Options<ListCaseEventsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListCaseEventsResponses, ListCaseEventsErrors, ThrowOnError>({
    url: "/cases/{case_id}/events",
    ...options,
  });

/**
 * Search Case Catalogue
 *
 * Search the item catalogue of the case's area (for "Pick item"). Read-only.
 *
 * 422 for a case without an area; 503 when the catalogue cannot be read.
 */
export const searchCaseCatalogue = <ThrowOnError extends boolean = false>(
  options: Options<SearchCaseCatalogueData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchCaseCatalogueResponses,
    SearchCaseCatalogueErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/catalogue", ...options });

/**
 * Get Case Crm Machines
 *
 * The "Machines in CRM" panel of the case's identified customer (display only, read-only).
 *
 * The machines of the customer's own CRM account in the case's legal entity, each with
 * the best F&O BOM link I2Q built (tier A to E), and per line whether the line's item
 * is a part of one of them. Only a confirmed customer, or one the engine is certain
 * of, is looked up: a suggested customer shows nothing. Empty (``available`` false)
 * until the CRM sync has built links; ``enabled`` false when ``RFQ_CRM_PANEL`` is off.
 * Nothing here feeds matching or auto-accept.
 */
export const getCaseCrmMachines = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseCrmMachinesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCaseCrmMachinesResponses,
    GetCaseCrmMachinesErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/crm-machines", ...options });

/**
 * Search Case Customers
 *
 * Search the customer accounts of the case's legal entity. Read-only.
 *
 * 422 for a case without a legal entity; 503 when master data cannot be read.
 */
export const searchCaseCustomers = <ThrowOnError extends boolean = false>(
  options: Options<SearchCaseCustomersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchCaseCustomersResponses,
    SearchCaseCustomersErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/customers", ...options });

/**
 * Accept Matched Lines
 *
 * Confirm I2Q's item on every matched line nobody decided yet, in ONE write.
 *
 * A line qualifies when its status is ``matched``, it has an item and an enquiry text,
 * it is not the whole mail standing in for a line, and it has no decision. With
 * ``line_keys`` only those lines are considered; a key the case does not hold is
 * skipped as ``not_in_case``. Every accepted line gets a Confirm decision and a
 * correction-log entry; the case gets one history entry and one version step, and the
 * first decision takes the case. When nothing qualifies, nothing is written and the
 * version stays. Undo stays per line (``decideLine`` with ``clear``). 409 on a stale
 * version, 422 for a parked order or a case without area, 404 outside the caller's areas.
 */
export const acceptMatchedLines = <ThrowOnError extends boolean = false>(
  options: Options<AcceptMatchedLinesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AcceptMatchedLinesResponses,
    AcceptMatchedLinesErrors,
    ThrowOnError
  >({
    url: "/cases/{case_id}/lines/accept-matched",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Bulk Set Case Status
 *
 * Set one status on up to 100 cases: each case is its own write, with the same rules.
 *
 * The rules of ``setCaseStatus`` apply to every case (version check, the first status
 * takes the case, reopening a colleague's case needs a manager). The call is not
 * atomic: ``results`` says per case what happened. A case outside the caller's areas
 * is ``not_found``, exactly like an unknown id. A case listed twice is a 422.
 */
export const bulkSetCaseStatus = <ThrowOnError extends boolean = false>(
  options: Options<BulkSetCaseStatusData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BulkSetCaseStatusResponses,
    BulkSetCaseStatusErrors,
    ThrowOnError
  >({
    url: "/work/bulk/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Bulk Assign Cases
 *
 * Take or release up to 100 cases; each case is its own write (see ``assignCase``).
 *
 * Taking a case a colleague holds is ``assigned_to_other`` (taking over stays a
 * single-case action). Not atomic; a case outside the caller's areas is ``not_found``.
 */
export const bulkAssignCases = <ThrowOnError extends boolean = false>(
  options: Options<BulkAssignCasesData, ThrowOnError>,
) =>
  (options.client ?? client).post<BulkAssignCasesResponses, BulkAssignCasesErrors, ThrowOnError>({
    url: "/work/bulk/assign",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Record Case Activity
 *
 * Record that the caller viewed, left or copied from a case (effort measurement).
 *
 * Stored as a case event without a version step: it never conflicts with a colleague's
 * write, never appears in the case history, never counts as work on the case, and is
 * only read in aggregate per area and week. One view per case and person per 10
 * minutes. 404 outside the caller's areas.
 */
export const recordCaseActivity = <ThrowOnError extends boolean = false>(
  options: Options<RecordCaseActivityData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RecordCaseActivityResponses,
    RecordCaseActivityErrors,
    ThrowOnError
  >({
    url: "/cases/{case_id}/activity",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get My Attention
 *
 * What is back on the caller's desk, for the sidebar badge (read only).
 *
 * Cases whose customer the caller confirmed and that I2Q evaluated again since,
 * the caller's cases waiting for the customer for 5 working days, the caller's open
 * cases older than 1 working day, and reply drafts ready on the caller's open cases.
 * Reminders exist only inside the app: nothing is mailed or posted.
 */
export const getMyAttention = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyAttentionData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMyAttentionResponses, GetMyAttentionErrors, ThrowOnError>({
    url: "/me/attention",
    ...options,
  });

/**
 * Get Autonomy Metrics
 *
 * How much of the work I2Q did itself, per area and week, and the open backlog.
 *
 * The funnel (mails in, filed by I2Q, inquiries, customer certain, every line certain,
 * draft ready, one click right on F&O truth with its 95 % lower bound), what sales
 * still did (touches, minutes on a case, confirmations, lines accepted in one click),
 * the open inquiries by age and the autonomy switches (read only). Aggregated per area
 * and week: no time or touch figure per person; the backlog names who holds how many
 * open cases. Managers (``see_pilot``) and admins (``see_team``, for the backlog of the
 * team part); 403 otherwise. Restricted to the caller's areas.
 */
export const getAutonomyMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<GetAutonomyMetricsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetAutonomyMetricsResponses,
    GetAutonomyMetricsErrors,
    ThrowOnError
  >({ url: "/metrics/autonomy", ...options });

/**
 * Get Workload Metrics
 *
 * Open inquiries per area and owner: the assignee, else the usual owner, else none.
 *
 * In shadow mode nobody is assigned, so the backlog by assignee is empty; this groups
 * the same open work list by who usually handles the customer (a suggestion only,
 * while the switch ``autonomy_suggest_owner`` is on). Read only: nothing is assigned
 * and nobody is told. Admins only (``see_team``, 403 otherwise; the product owner, 15 Oct
 * 2026), restricted to the caller's areas.
 */
export const getWorkloadMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<GetWorkloadMetricsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetWorkloadMetricsResponses,
    GetWorkloadMetricsErrors,
    ThrowOnError
  >({ url: "/metrics/workload", ...options });

/**
 * Get Executive Metrics
 *
 * The executive summary and the monthly report: one aggregated, cached answer.
 *
 * Matches what sales quoted (whole thread, single mail beside it, revision mails apart
 * once measurable), right when I2Q is sure (items and customer), inquiries handled, done
 * without a person, how fast, the quotation value per currency, a weekly trend, each
 * area against the go-live bar (never added up), the status line and the open
 * decisions. Every figure counts completed calendar weeks (the period against the one
 * before) or one calendar month (``month``), states its base and is null where nothing
 * was measured. Managers and executives only (capability ``see_exec_summary``, 403
 * otherwise), restricted to the caller's areas; ``area`` narrows further (403 for an
 * area the caller lacks). Served from a cache: 10 minutes,
 * 6 hours for a completed month (``computed_at`` says when). No cost, margin or
 * per-person figure.
 */
export const getExecutiveMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<GetExecutiveMetricsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetExecutiveMetricsResponses,
    GetExecutiveMetricsErrors,
    ThrowOnError
  >({ url: "/metrics/executive", ...options });

/**
 * Get Case Customer Memory
 *
 * The accounts earlier documents for this case's sender went to (read only).
 *
 * Learned from the reps' sent quotations and order confirmations, the quotations of
 * the order system with this contact, the reps' documents for earlier cases and the
 * reps' confirmations; the case's own documents do not count. For a colleague's
 * forward the address the mail was forwarded from is read. Also the accounts of the
 * sender's mail domain. 404 outside the caller's areas; 503 without the case store.
 */
export const getCaseCustomerMemory = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseCustomerMemoryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCaseCustomerMemoryResponses,
    GetCaseCustomerMemoryErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/customer/memory", ...options });

/**
 * Get Case Installed Base
 *
 * Assemblies matched by parts the case's customer was invoiced or quoted (read only).
 *
 * The customer sales confirmed for the case's company, else the engine's customer when it
 * is certain; evidence before the inquiry arrived only. Display only: nothing here accepts
 * a line or changes the draft. ``enabled`` false when ``RFQ_IB_PANEL`` is off for the
 * company; ``available`` false when the customer is open or the data cannot be read.
 * 404 outside the caller's areas; 503 without the case store.
 */
export const getCaseInstalledBase = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseInstalledBaseData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCaseInstalledBaseResponses,
    GetCaseInstalledBaseErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/installed-base", ...options });

/**
 * Get Customer Matching Metrics
 *
 * The engine's customer against the customer number on the rep's document.
 *
 * Per area and per rule: certain right or wrong, suggested right or wrong, none. A
 * rule that was certain and wrong in the window is flagged. Cases a rep confirmed are
 * left out (the stored customer is then the rep's). Managers only (403 otherwise),
 * restricted to the caller's areas (403 for another area).
 *
 * The window is the last ``days`` up to now, or ``from`` to ``to`` (both days whole),
 * so the Operations dashboard can ask for the same completed weeks as its other cards.
 */
export const getCustomerMatchingMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomerMatchingMetricsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetCustomerMatchingMetricsResponses,
    GetCustomerMatchingMetricsErrors,
    ThrowOnError
  >({ url: "/metrics/customer-matching", ...options });

/**
 * Get Classification Audit
 *
 * Parked purchase orders whose stored outcome was a quotation (read-only).
 *
 * End user review of 11 Oct 2026: classification audit candidates, not proven missed
 * inquiries. A person reviews the original mail; nothing is reclassified and nothing is
 * written. Managers only (403 otherwise), restricted to the caller's areas.
 */
export const getClassificationAudit = <ThrowOnError extends boolean = false>(
  options?: Options<GetClassificationAuditData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetClassificationAuditResponses,
    GetClassificationAuditErrors,
    ThrowOnError
  >({ url: "/metrics/classification-audit", ...options });

/**
 * Get Fo Draft
 *
 * The quotation draft check of one case: fourteen checks and a payload preview.
 *
 * ``ready`` is true only when every check is ok: the case is a finished quote
 * request of ONE live legal entity, no quotation exists yet, the case is assigned to
 * the caller and open, a PERSON confirmed the customer (the engine being certain is
 * not enough), every line carries a rep's decision, the items are in this area's
 * catalogue and can be sold, quantities, units, prices (one currency, not expired)
 * and the margin verdict are in order, the header fields are known (division, business
 * type, sales product and the sales pool the entity rules propose from the item
 * groups), master data is fresh and no entity rule holds the quotation. Every
 * blocked check says why in one sentence.
 *
 * Nothing is sent and nothing is stored. ``ready`` enables nothing:
 * ``write_enabled`` is always false and ``gates`` lists the seven locks that stay
 * closed. Prices are the SALES prices of the same lookup the case page uses; the
 * response never carries a cost, a contribution ratio or a margin threshold, for
 * any role. 404 for an unknown case and for a case outside the caller's areas.
 */
export const getFoDraft = <ThrowOnError extends boolean = false>(
  options: Options<GetFoDraftData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFoDraftResponses, GetFoDraftErrors, ThrowOnError>({
    url: "/cases/{case_id}/fo-draft",
    ...options,
  });

/**
 * Get Answer Draft
 *
 * The newest stored reply draft of a case (``draft`` null when none). Makes nothing.
 */
export const getAnswerDraft = <ThrowOnError extends boolean = false>(
  options: Options<GetAnswerDraftData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetAnswerDraftResponses, GetAnswerDraftErrors, ThrowOnError>({
    url: "/cases/{case_id}/answer-draft",
    ...options,
  });

/**
 * Create Answer Draft
 *
 * A proposed reply to the customer, made by the drafting agent (or the cached one).
 *
 * The agent reads the case through read-only tools (lines with SALES prices only,
 * customer, mail, attachments, earlier quotations and replies, catalogue, purchase
 * history), writes in the customer's language and the desk's style, and a
 * deterministic verifier flags every code, number, date, promise or word it cannot
 * back with the case data. Nothing is sent and no Outlook draft is created:
 * ``send_enabled`` is always false. ``refresh`` makes a new draft even when one is
 * cached. 404 outside the caller's areas, 422 for a case that is not a quote request
 * or an order, 429 after 20 new drafts per person per hour, 503 when the model is
 * busy or the app DB is down.
 */
export const createAnswerDraft = <ThrowOnError extends boolean = false>(
  options: Options<CreateAnswerDraftData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateAnswerDraftResponses,
    CreateAnswerDraftErrors,
    ThrowOnError
  >({
    url: "/cases/{case_id}/answer-draft",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Case Translation
 *
 * The stored translation of the case's mail into ``target``, without a model call.
 *
 * ``translation`` is null when the mail still needs translating (then POST). A mail
 * already in ``target`` or without a stored body is answered here as well.
 */
export const getCaseTranslation = <ThrowOnError extends boolean = false>(
  options: Options<GetCaseTranslationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCaseTranslationResponses,
    GetCaseTranslationErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/translation", ...options });

/**
 * Translate Case Mail
 *
 * The case's customer mail translated into ``target`` (or the cached translation).
 *
 * Translates the subject and the current part of the mail (not the quoted earlier
 * messages) with the translation deployment, once per text and language: a cached or
 * copied translation makes no model call. No call either when the mail is already in
 * ``target`` (``same_language``). Every number, code and address of the original is
 * checked in the translation; ``numbers_ok`` is false when one is missing. A mail longer
 * than 12000 characters is cut (``truncated``). Read-only: nothing is sent. 404 outside
 * the caller's areas, 429 after 60 model calls per person per hour, 503 when the
 * model is busy or the app DB is down. A refused request or an answer that is not a
 * translation is ``unavailable``; it counts towards the limit and the same text is not
 * sent to the model again for 15 minutes.
 */
export const translateCaseMail = <ThrowOnError extends boolean = false>(
  options: Options<TranslateCaseMailData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TranslateCaseMailResponses,
    TranslateCaseMailErrors,
    ThrowOnError
  >({
    url: "/cases/{case_id}/translation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Quotation Approval
 *
 * The current quotation approval of a case and the earlier ones, newest first.
 */
export const getQuotationApproval = <ThrowOnError extends boolean = false>(
  options: Options<GetQuotationApprovalData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetQuotationApprovalResponses,
    GetQuotationApprovalErrors,
    ThrowOnError
  >({ url: "/cases/{case_id}/quotation-approval", ...options });

/**
 * Record Quotation Approval
 *
 * Approve the quotation draft of a case. Creating quotations stays switched off.
 *
 * The preview is rebuilt on the server through the same check as
 * ``GET /cases/{id}/fo-draft``; every one of the fourteen checks must pass (422 with
 * the blocked checks otherwise, which also covers a case assigned to a colleague).
 * The approval freezes the payload, its idempotency key, reference and correlation id
 * in the app DB. The same decisions approved again answer 200 with the existing
 * approval; changed lines, customer or currency give a new approval (201) and the
 * old one is superseded. Nothing is sent, nothing is queued, nothing reads it.
 */
export const approveQuotationDraft = <ThrowOnError extends boolean = false>(
  options: Options<ApproveQuotationDraftData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApproveQuotationDraftResponses,
    ApproveQuotationDraftErrors,
    ThrowOnError
  >({
    url: "/cases/{case_id}/quotation-approval",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Withdraw Quotation Approval
 *
 * Withdraw the current approval (the approver, or a manager with ``reopen_others``).
 */
export const withdrawQuotationApproval = <ThrowOnError extends boolean = false>(
  options: Options<WithdrawQuotationApprovalData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WithdrawQuotationApprovalResponses,
    WithdrawQuotationApprovalErrors,
    ThrowOnError
  >({
    url: "/cases/{case_id}/quotation-approval/withdraw",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Approve Line Price
 *
 * A manager approves the price of one line (``approve: false`` takes it back).
 *
 * The quotation draft check then treats the line as passing the margin rule. The
 * answer carries no figure. 404 outside the caller's areas first, 403 without
 * ``approve_price`` second.
 */
export const approveLinePrice = <ThrowOnError extends boolean = false>(
  options: Options<ApproveLinePriceData, ThrowOnError>,
) =>
  (options.client ?? client).post<ApproveLinePriceResponses, ApproveLinePriceErrors, ThrowOnError>({
    url: "/cases/{case_id}/lines/{line_index}/price-approval",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Case Feedback
 *
 * The feedback of a case: a rep sees their own rows, a manager every row.
 *
 * @deprecated
 */
export const listCaseFeedback = <ThrowOnError extends boolean = false>(
  options: Options<ListCaseFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListCaseFeedbackResponses, ListCaseFeedbackErrors, ThrowOnError>({
    url: "/cases/{case_id}/feedback",
    ...options,
  });

/**
 * Record Case Feedback
 *
 * Pilot feedback on a case or a line: right or wrong, with an optional comment.
 *
 * Deprecated: a thin wrapper over the feedback hub (``POST /feedback``), kept so an
 * open tab on an older bundle keeps working. The verdict is stored as a ``model`` item
 * with the case snapshot; a newer verdict replaces the author's earlier one on the same
 * case, line and topic. The case history says that feedback was given, never the
 * comment. Feedback is not a decision: it does not change the case or its version.
 *
 * @deprecated
 */
export const recordCaseFeedback = <ThrowOnError extends boolean = false>(
  options: Options<RecordCaseFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RecordCaseFeedbackResponses,
    RecordCaseFeedbackErrors,
    ThrowOnError
  >({
    url: "/cases/{case_id}/feedback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Pilot Metrics
 *
 * The pilot summary of one area: cases touched, time to first action and to done,
 * customer confirmations against the engine, line decisions, feedback, the stop-rule
 * list and the check against the reps' own documents. Default window: the last 30
 * days up to today. No cost or margin figure.
 */
export const getPilotMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<GetPilotMetricsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetPilotMetricsResponses, GetPilotMetricsErrors, ThrowOnError>({
    url: "/metrics/pilot",
    ...options,
  });

/**
 * Get Pilot Export
 *
 * The pilot rows as CSV, one row per case and rep (no comment text).
 */
export const getPilotExport = <ThrowOnError extends boolean = false>(
  options?: Options<GetPilotExportData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetPilotExportResponses, GetPilotExportErrors, ThrowOnError>({
    url: "/metrics/pilot/export",
    ...options,
  });

/**
 * Get Margin Thresholds
 *
 * The margin threshold of each of the caller's areas and where it comes from.
 */
export const getMarginThresholds = <ThrowOnError extends boolean = false>(
  options?: Options<GetMarginThresholdsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetMarginThresholdsResponses,
    GetMarginThresholdsErrors,
    ThrowOnError
  >({ url: "/settings/margin-thresholds", ...options });

/**
 * Get Rule Set
 *
 * The active entity rules of the caller's areas: every rule with mode and source.
 *
 * Read-only: rules are changed in code and data files, never through the API. The
 * margin rule's ``value`` (the threshold) is filled only with ``see_margin``.
 */
export const getRuleSet = <ThrowOnError extends boolean = false>(
  options?: Options<GetRuleSetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetRuleSetResponses, GetRuleSetErrors, ThrowOnError>({
    url: "/rules",
    ...options,
  });

/**
 * Get Entity Rules
 *
 * Every rule of one legal entity (``dk fr in es uk usl mx wgg cz``) with mode and source.
 *
 * 404 for an unknown entity and for one outside the caller's areas (checked first),
 * 403 without ``see_rules``.
 */
export const getEntityRules = <ThrowOnError extends boolean = false>(
  options: Options<GetEntityRulesData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetEntityRulesResponses, GetEntityRulesErrors, ThrowOnError>({
    url: "/rules/{entity}",
    ...options,
  });

/**
 * Get Entity Rule Table
 *
 * One data table of the rules, the rows that apply to ``entity``, paged.
 *
 * ``q`` keeps the rows with a cell that contains it (case-insensitive). Read-only.
 */
export const getEntityRuleTable = <ThrowOnError extends boolean = false>(
  options: Options<GetEntityRuleTableData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetEntityRuleTableResponses,
    GetEntityRuleTableErrors,
    ThrowOnError
  >({ url: "/rules/{entity}/tables/{table}", ...options });

/**
 * List Learned Proposals
 *
 * List the proposed broad aliases awaiting review (the approval queue). Read-only.
 *
 * Per-area visibility: a proposal belongs to the mailbox of the case its correction
 * was made on. A proposal without a stored case is listed for ``Area.All`` only.
 */
export const listLearnedProposals = <ThrowOnError extends boolean = false>(
  options?: Options<ListLearnedProposalsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListLearnedProposalsResponses,
    ListLearnedProposalsErrors,
    ThrowOnError
  >({ url: "/learned/proposals", ...options });

/**
 * Approve Learned Alias
 *
 * Approve a proposed broad alias — flip it to active so it starts matching. Local write.
 *
 * Managers only (capability ``approve_learned``, 403 otherwise; review SA-06 of 12 Oct
 * 2026). The capability is checked before the store is read, because the store's scope
 * filter and the write are one statement; a manager without the area still gets a 404,
 * exactly like an unknown id. ``approved_by`` records the caller.
 */
export const approveLearnedAlias = <ThrowOnError extends boolean = false>(
  options: Options<ApproveLearnedAliasData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApproveLearnedAliasResponses,
    ApproveLearnedAliasErrors,
    ThrowOnError
  >({ url: "/learned/{alias_id}/approve", ...options });

/**
 * Retract Learned Alias
 *
 * Retract a learned alias — flip it to retracted so it stops matching. Local write.
 *
 * Managers only (capability ``approve_learned``, 403 otherwise), checked before the
 * store is read like :func:`approve_learned_alias`. A manager without the area gets a
 * 404, exactly like an unknown id (the store's own scope filter, in the same statement
 * as the write).
 */
export const retractLearnedAlias = <ThrowOnError extends boolean = false>(
  options: Options<RetractLearnedAliasData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RetractLearnedAliasResponses,
    RetractLearnedAliasErrors,
    ThrowOnError
  >({ url: "/learned/{alias_id}/retract", ...options });

/**
 * Get Sales Truth Summary
 *
 * The tab "Overview": KPIs, the funnel per area, the link sources, the differences.
 *
 * Also the learnings per status and the three TRUTH LEARN switches. Read only.
 */
export const getSalesTruthSummary = <ThrowOnError extends boolean = false>(
  options?: Options<GetSalesTruthSummaryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSalesTruthSummaryResponses,
    GetSalesTruthSummaryErrors,
    ThrowOnError
  >({ url: "/sales-truth/summary", ...options });

/**
 * List Sales Truth Inquiries
 *
 * The tab "Inquiries": linked inquiries of the window, newest first, one page.
 *
 * A ``taker`` filter never matches an inquiry of Germany or France (S3). Read only.
 */
export const listSalesTruthInquiries = <ThrowOnError extends boolean = false>(
  options?: Options<ListSalesTruthInquiriesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListSalesTruthInquiriesResponses,
    ListSalesTruthInquiriesErrors,
    ThrowOnError
  >({ url: "/sales-truth/inquiries", ...options });

/**
 * Get Sales Truth Inquiry
 *
 * The drawer of one inquiry: the link facts, the line difference, the learnings.
 */
export const getSalesTruthInquiry = <ThrowOnError extends boolean = false>(
  options: Options<GetSalesTruthInquiryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSalesTruthInquiryResponses,
    GetSalesTruthInquiryErrors,
    ThrowOnError
  >({ url: "/sales-truth/inquiries/{case_id}", ...options });

/**
 * List Sales Truth People
 *
 * The tab "Sales people": per person the linked inquiries, orders and matches.
 *
 * No score and no rank; never a person of Germany or France (S3). Read only.
 */
export const listSalesTruthPeople = <ThrowOnError extends boolean = false>(
  options?: Options<ListSalesTruthPeopleData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListSalesTruthPeopleResponses,
    ListSalesTruthPeopleErrors,
    ThrowOnError
  >({ url: "/sales-truth/people", ...options });

/**
 * List Truth Learnings
 *
 * The tab "Learnings": what I2Q learns from the quotations, newest first. Read only.
 */
export const listTruthLearnings = <ThrowOnError extends boolean = false>(
  options?: Options<ListTruthLearningsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListTruthLearningsResponses,
    ListTruthLearningsErrors,
    ThrowOnError
  >({ url: "/sales-truth/learnings", ...options });

/**
 * Approve Truth Learning
 *
 * Approve one learning: it becomes active and teaches I2Q. Local app-DB write.
 *
 * Needs ``see_sales_truth`` and ``approve_learned`` (403 before the store is read). A
 * learning outside the caller's areas is a 404, like an unknown id.
 */
export const approveTruthLearning = <ThrowOnError extends boolean = false>(
  options: Options<ApproveTruthLearningData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApproveTruthLearningResponses,
    ApproveTruthLearningErrors,
    ThrowOnError
  >({ url: "/sales-truth/learnings/{learning_id}/approve", ...options });

/**
 * Retract Truth Learning
 *
 * Retract one learning and the alias it wrote, so it stops matching. Local write.
 *
 * Needs ``see_sales_truth`` and ``approve_learned`` (403 before the store is read).
 */
export const retractTruthLearning = <ThrowOnError extends boolean = false>(
  options: Options<RetractTruthLearningData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RetractTruthLearningResponses,
    RetractTruthLearningErrors,
    ThrowOnError
  >({ url: "/sales-truth/learnings/{learning_id}/retract", ...options });

/**
 * Set Truth Learning Multi Account
 *
 * Set or clear the multi-account mark of a customer learning's sender. Local write.
 *
 * Decision D5: a sender with the mark buys for more than one customer account, so I2Q
 * does not use the sender alone to find the customer (switch
 * ``truth_learn_multi_account``). A cleared mark is never set again by the rule. Needs
 * ``see_sales_truth`` and ``approve_learned`` (403 before the store is read); 404 outside
 * the caller's areas; 422 for an item learning. Works while the switch is OFF (it only
 * stores the decision).
 */
export const setTruthLearningMultiAccount = <ThrowOnError extends boolean = false>(
  options: Options<SetTruthLearningMultiAccountData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SetTruthLearningMultiAccountResponses,
    SetTruthLearningMultiAccountErrors,
    ThrowOnError
  >({
    url: "/sales-truth/learnings/{learning_id}/multi-account",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Learning Stats
 *
 * The learning-effectiveness metric — errors prevented, aliases learned, repeat-error guard.
 *
 * Reads the app DB (``DATABASE_URL``) only; read-only over every external system. Returns a
 * clean 503 when the correction store is unconfigured/unreachable. ``errors_prevented`` is the
 * sum of every learned alias's apply-first hit counter — each an error that never repeated.
 *
 * Per-area visibility: counts only corrections made on cases from the caller's
 * mailboxes and the aliases learned from them.
 */
export const getLearningStats = <ThrowOnError extends boolean = false>(
  options?: Options<GetLearningStatsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetLearningStatsResponses, GetLearningStatsErrors, ThrowOnError>({
    url: "/metrics/learning",
    ...options,
  });

/**
 * List Feedback
 *
 * The triage list: items of the caller's areas (every area for admins), newest first.
 *
 * Confirmations ("noted") and superseded verdicts are hidden unless asked for.
 */
export const listFeedback = <ThrowOnError extends boolean = false>(
  options?: Options<ListFeedbackData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListFeedbackResponses, ListFeedbackErrors, ThrowOnError>({
    url: "/feedback",
    ...options,
  });

/**
 * Create Feedback
 *
 * Give feedback: a bug, a wrong result, an idea, a change request or a question.
 *
 * The server adds the context (page path, app version, derive version, deployment,
 * prompt versions, the author's roles and areas) and, on a case, the case snapshot
 * built from the masked case (never cost or margin). The mail text is stored only
 * with ``include_mail_text``. A verdict on a case replaces the author's earlier one on
 * the same case, line and topic. At most 30 new items per person per hour. An
 * executive-only caller sees no case, so feedback naming one is a 403 for them.
 */
export const createFeedback = <ThrowOnError extends boolean = false>(
  options: Options<CreateFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateFeedbackResponses, CreateFeedbackErrors, ThrowOnError>({
    url: "/feedback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List My Feedback
 *
 * The caller's own feedback items, newest first (with the unread flag).
 */
export const listMyFeedback = <ThrowOnError extends boolean = false>(
  options?: Options<ListMyFeedbackData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListMyFeedbackResponses, ListMyFeedbackErrors, ThrowOnError>({
    url: "/feedback/mine",
    ...options,
  });

/**
 * Get Feedback Unread Count
 *
 * How many of the caller's items have a reply or a status change they have not seen.
 */
export const getFeedbackUnreadCount = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeedbackUnreadCountData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetFeedbackUnreadCountResponses,
    GetFeedbackUnreadCountErrors,
    ThrowOnError
  >({ url: "/feedback/unread-count", ...options });

/**
 * Get Feedback Summary
 *
 * Counts of the filtered items per type, status, area and impact (triage only).
 */
export const getFeedbackSummary = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeedbackSummaryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetFeedbackSummaryResponses,
    GetFeedbackSummaryErrors,
    ThrowOnError
  >({ url: "/feedback/summary", ...options });

/**
 * Export Feedback
 *
 * The filtered items as CSV: the typed texts, never the snapshot or the mail text.
 */
export const exportFeedback = <ThrowOnError extends boolean = false>(
  options?: Options<ExportFeedbackData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportFeedbackResponses, ExportFeedbackErrors, ThrowOnError>({
    url: "/feedback/export.csv",
    ...options,
  });

/**
 * Export Feedback Eval
 *
 * Wrong-result feedback as labelled examples for the eval owner (JSON Lines).
 *
 * Each row is a candidate golden item in the ``silver`` tier with the engine state, the
 * label and what sales did on the case (``implicit``). Nothing retrains and nothing
 * feeds ``make eval``; rejected items never leave.
 */
export const exportFeedbackEval = <ThrowOnError extends boolean = false>(
  options?: Options<ExportFeedbackEvalData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ExportFeedbackEvalResponses,
    ExportFeedbackEvalErrors,
    ThrowOnError
  >({ url: "/feedback/eval-export", ...options });

/**
 * Get Feedback
 *
 * One item. The author sees what they sent, the status and the replies; a triager
 * in scope also sees the owner, the internal notes, the eval label and the snapshot
 * (withheld for a case outside the triager's own areas).
 */
export const getFeedback = <ThrowOnError extends boolean = false>(
  options: Options<GetFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFeedbackResponses, GetFeedbackErrors, ThrowOnError>({
    url: "/feedback/{feedback_id}",
    ...options,
  });

/**
 * Triage Feedback
 *
 * Triage one item at ``version``: status, owner, type, topic, area, impact, duplicate
 * link, eval label and a reply to the author, with one activity per change.
 */
export const triageFeedback = <ThrowOnError extends boolean = false>(
  options: Options<TriageFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).patch<TriageFeedbackResponses, TriageFeedbackErrors, ThrowOnError>({
    url: "/feedback/{feedback_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Mark Feedback Seen
 *
 * The author opened the item: it no longer counts as unread.
 */
export const markFeedbackSeen = <ThrowOnError extends boolean = false>(
  options: Options<MarkFeedbackSeenData, ThrowOnError>,
) =>
  (options.client ?? client).post<MarkFeedbackSeenResponses, MarkFeedbackSeenErrors, ThrowOnError>({
    url: "/feedback/{feedback_id}/seen",
    ...options,
  });

/**
 * Add Feedback Comment
 *
 * A reply (the author sees it) or, for triagers, an internal note (the author does not).
 *
 * At most 20 per item and person per hour.
 */
export const addFeedbackComment = <ThrowOnError extends boolean = false>(
  options: Options<AddFeedbackCommentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AddFeedbackCommentResponses,
    AddFeedbackCommentErrors,
    ThrowOnError
  >({
    url: "/feedback/{feedback_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Training Progress
 *
 * The caller's own training progress; empty before the first write.
 */
export const getTrainingProgress = <ThrowOnError extends boolean = false>(
  options?: Options<GetTrainingProgressData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetTrainingProgressResponses,
    GetTrainingProgressErrors,
    ThrowOnError
  >({ url: "/training/progress", ...options });

/**
 * Put Training Module
 *
 * Start a module, move to a slide or complete a lesson, for the caller only.
 */
export const putTrainingModule = <ThrowOnError extends boolean = false>(
  options: Options<PutTrainingModuleData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutTrainingModuleResponses, PutTrainingModuleErrors, ThrowOnError>(
    {
      url: "/training/progress/modules/{module_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * Record Training Attempt
 *
 * Record one knowledge-check attempt of the caller (only a pass stores a score).
 */
export const recordTrainingAttempt = <ThrowOnError extends boolean = false>(
  options: Options<RecordTrainingAttemptData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RecordTrainingAttemptResponses,
    RecordTrainingAttemptErrors,
    ThrowOnError
  >({
    url: "/training/progress/attempts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Put Training State
 *
 * Set the caller's resume point, dismiss the first-login note, or complete the course.
 */
export const putTrainingState = <ThrowOnError extends boolean = false>(
  options: Options<PutTrainingStateData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutTrainingStateResponses, PutTrainingStateErrors, ThrowOnError>({
    url: "/training/progress/state",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reset Training
 *
 * Restart the caller's training. The first completion stays on record.
 */
export const resetTraining = <ThrowOnError extends boolean = false>(
  options: Options<ResetTrainingData, ThrowOnError>,
) =>
  (options.client ?? client).post<ResetTrainingResponses, ResetTrainingErrors, ThrowOnError>({
    url: "/training/progress/reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Training Team
 *
 * Training uptake of the people in the caller's areas (admins only, ``see_team``).
 *
 * A learner is listed when their areas at the last write overlap the caller's
 * (everyone for Area.All); ``area`` narrows the result. ``not_started`` lists the
 * people with case events in the caller's mailbox scope in the last 30 days and no
 * training row.
 */
export const getTrainingTeam = <ThrowOnError extends boolean = false>(
  options?: Options<GetTrainingTeamData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetTrainingTeamResponses, GetTrainingTeamErrors, ThrowOnError>({
    url: "/training/team",
    ...options,
  });

/**
 * Record Usage
 *
 * Record what the caller did in the app: a batch of up to 50 usage events.
 *
 * The user is the session; the body names none. The kind of an event comes from the
 * vocabulary, the entity from the case, the time from the server clock. An event with
 * an unknown or server-only name, an unknown route, or a detail key or value outside
 * the vocabulary is refused and counted in ``rejected``; the others are stored. A case
 * outside the caller's areas is not stored with the event, and the answer does not say
 * so. No area and no role is needed. With ``RFQ_USAGE_LOG`` off nothing is stored
 * (``enabled`` false). A failing store is never an error for the caller: the answer is
 * still 202, with every event counted in ``rejected``. ``session_id`` is a random id of
 * the browser tab (a UUID or 32 hex characters); a value taken from the session cookie
 * is a 422, and so is an ``app_version`` taken from it. An ``app_version`` that is not
 * the build id of the server, a hex commit id or ``dev`` is stored as ``other``.
 */
export const recordUsage = <ThrowOnError extends boolean = false>(
  options: Options<RecordUsageData, ThrowOnError>,
) =>
  (options.client ?? client).post<RecordUsageResponses, RecordUsageErrors, ThrowOnError>({
    url: "/usage",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Usage Metrics
 *
 * Who uses I2Q, how, and where people stop: aggregates of the usage log.
 *
 * People, sign-ins and sessions per day, the funnel per entity (from the record of
 * decisions, so it has history from before the usage log), the use of each feature
 * with the ones never used, the deeper-search figures, the time on a case, and the
 * trouble people had (errors seen, slow pages, dialogs closed without a save, searches
 * without a result). Counts only: no e-mail address and no case id. Simulation
 * personas are left out unless ``include_sim`` is true.
 *
 * Admins only (capability ``see_usage``, 403 otherwise; the product owner, 15 Oct 2026).
 * An admin (``see_usage_people``) reads every entity and nothing is withheld. ``area``
 * narrows the scope. A session with ``see_usage`` but without ``see_usage_people`` (no
 * role grants that today; a manager did until 15 Oct 2026) reads the areas it holds; a
 * figure built from fewer than ``min_group`` people is null, the caller is not one of
 * those people, and a narrowed answer holds no figure (``narrowing_withheld``) while
 * one area has people, but fewer than ``min_group``. Served from a cache for up to 5
 * minutes; such an answer is cached for its caller alone.
 */
export const getUsageMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsageMetricsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetUsageMetricsResponses, GetUsageMetricsErrors, ThrowOnError>({
    url: "/metrics/usage",
    ...options,
  });

/**
 * Get Usage People
 *
 * The use of each person in the period, last seen first (at most 500 rows).
 *
 * Days active, sign-ins, sessions, active minutes, cases opened and decided, replies
 * prepared and copied, errors seen and the training progress. Admins only (capability
 * ``see_usage_people``, 403 otherwise): a manager reads the aggregates of
 * ``GET /metrics/usage`` and never a row per person. Not cached.
 */
export const getUsagePeople = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsagePeopleData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetUsagePeopleResponses, GetUsagePeopleErrors, ThrowOnError>({
    url: "/metrics/usage/people",
    ...options,
  });

/**
 * List Discussions
 *
 * Every topic: open first, then the decisions of record, then parked.
 */
export const listDiscussions = <ThrowOnError extends boolean = false>(
  options?: Options<ListDiscussionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListDiscussionsResponses, ListDiscussionsErrors, ThrowOnError>({
    url: "/discussions",
    ...options,
  });

/**
 * Create Discussion
 *
 * Open a topic under the caller's own e-mail (status ``open``, no comments yet).
 */
export const createDiscussion = <ThrowOnError extends boolean = false>(
  options: Options<CreateDiscussionData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateDiscussionResponses, CreateDiscussionErrors, ThrowOnError>({
    url: "/discussions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Discussion
 *
 * One topic with its thread (comments oldest first).
 */
export const getDiscussion = <ThrowOnError extends boolean = false>(
  options: Options<GetDiscussionData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetDiscussionResponses, GetDiscussionErrors, ThrowOnError>({
    url: "/discussions/{discussion_id}",
    ...options,
  });

/**
 * Decide Discussion
 *
 * Set the status and the decision of record (managers only).
 *
 * ``decided`` needs a decision text; the caller and the time are recorded when the
 * topic becomes decided or its decision text changes, and kept when a save changes
 * neither (so a re-save does not take the decision over from the manager who made
 * it). ``open`` and ``parked`` keep the decision text as given (null clears it) and
 * clear who decided and when. Last write wins.
 *
 * A business decision set ``decided`` also needs ``decided_by_role`` (the ROLE that
 * decided, never a person); ``chosen_option`` must be one of its option keys. Both are
 * cleared for any other status.
 */
export const decideDiscussion = <ThrowOnError extends boolean = false>(
  options: Options<DecideDiscussionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<DecideDiscussionResponses, DecideDiscussionErrors, ThrowOnError>(
    {
      url: "/discussions/{discussion_id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * Add Discussion Comment
 *
 * Leave a named comment on a topic; answers the topic with the thread re-read.
 */
export const addDiscussionComment = <ThrowOnError extends boolean = false>(
  options: Options<AddDiscussionCommentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AddDiscussionCommentResponses,
    AddDiscussionCommentErrors,
    ThrowOnError
  >({
    url: "/discussions/{discussion_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Decision Frame
 *
 * Set the frame of a business decision (managers only; the topic becomes one).
 *
 * The owner ROLE, the milestone and its date, 2 to 6 options with neutral properties
 * and what I2Q runs with today. State changes in the app: no deploy is needed. The
 * texts are stored as given and rendered as text. Last write wins. 409 for a decided
 * topic: set it back to open first, so a decision never points to an option the new
 * frame does not have.
 */
export const setDecisionFrame = <ThrowOnError extends boolean = false>(
  options: Options<SetDecisionFrameData, ThrowOnError>,
) =>
  (options.client ?? client).put<SetDecisionFrameResponses, SetDecisionFrameErrors, ThrowOnError>({
    url: "/discussions/{discussion_id}/frame",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Master Data Defects
 *
 * The master-data defects of the caller's entities, most cases first.
 *
 * Each row: kind, entity, the account or item, what is wrong, how to fix it in F&O, the
 * cases of the last 30 days (ids only inside the caller's areas), first seen, status.
 * ``by_kind`` counts the open records of every kind; ``computed_at`` is the last check
 * (null: it never ran). Every signed-in person; 404 for an entity the caller does not
 * hold. Read from the app table only, no model call.
 */
export const listMasterDataDefects = <ThrowOnError extends boolean = false>(
  options?: Options<ListMasterDataDefectsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListMasterDataDefectsResponses,
    ListMasterDataDefectsErrors,
    ThrowOnError
  >({ url: "/master-data/defects", ...options });

/**
 * Export Master Data Defects
 *
 * The filtered defects as CSV for the data owner: no case id, no person.
 */
export const exportMasterDataDefects = <ThrowOnError extends boolean = false>(
  options?: Options<ExportMasterDataDefectsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ExportMasterDataDefectsResponses,
    ExportMasterDataDefectsErrors,
    ThrowOnError
  >({ url: "/master-data/defects.csv", ...options });

/**
 * Mark Master Data Defect
 *
 * Mark a defect "In progress", "Not a defect" (with a reason) or "Open" again.
 *
 * Every signed-in person marks the defects of their entities; a defect of an entity
 * the caller does not hold is a 404, like an unknown one. The ROLE is stored, never
 * the person: ``manager``, else ``admin``, else ``sales``. The next nightly check keeps
 * the mark while the defect stays.
 */
export const markMasterDataDefect = <ThrowOnError extends boolean = false>(
  options: Options<MarkMasterDataDefectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    MarkMasterDataDefectResponses,
    MarkMasterDataDefectErrors,
    ThrowOnError
  >({
    url: "/master-data/defects/{defect_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Process Mining Findings
 *
 * The findings: real waiting, re-work, local differences, lookups, work outside F&O.
 *
 * A small catalog of detectors (``process_mining/findings.py``) runs on the event log
 * and the current-key imports on every request; nothing is stored, so the findings
 * always match the filters. Codes and numbers only: the page owns every sentence. A
 * Defender or NOVA signal is always paired with its control window; a file or a site is
 * named only when 3 or more people open it. Data gaps come as coverage warnings.
 *
 * The redesign (16 Oct 2026): every finding comes back (no cap) with its pain point,
 * severity, weak reasons, headline row and ``dup_of``; ``pain_points`` holds one row
 * per pain point with a cell per area and a weekly trend. The tab "Pain points" asks
 * without ``area`` and filters in the browser, so the detectors run once (A2).
 * Round 4: ``qtype`` and the answer cache (``PM_CACHE_TTL_S``, per build and import).
 */
export const getProcessMiningFindings = <ThrowOnError extends boolean = false>(
  options?: Options<GetProcessMiningFindingsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetProcessMiningFindingsResponses,
    GetProcessMiningFindingsErrors,
    ThrowOnError
  >({ url: "/process-mining/findings", ...options });

/**
 * Get Process Mining Summary
 *
 * Layer 1, the value stream: inquiry to quotation to order per area.
 *
 * Counts, the real conversion (ordered within 30 days, paperwork out), lead times
 * (median and p80, elapsed, never work), the gaps between the steps split by working
 * hours, re-work of the quotation cases, the link share (any tier and exact) and the
 * acyclic volume flow. Every figure carries source, window and coverage. Cached.
 */
export const getProcessMiningSummary = <ThrowOnError extends boolean = false>(
  options?: Options<GetProcessMiningSummaryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetProcessMiningSummaryResponses,
    GetProcessMiningSummaryErrors,
    ThrowOnError
  >({ url: "/process-mining/summary", ...options });

/**
 * Get Process Mining Map
 *
 * Layer 2, the process map: directly-follows edges with cases and elapsed time.
 *
 * Edges below ``min_share`` of the cases (or below 5 cases) are hidden and counted;
 * an edge back to a lower stage or to the same activity is a re-work edge.
 */
export const getProcessMiningMap = <ThrowOnError extends boolean = false>(
  options?: Options<GetProcessMiningMapData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetProcessMiningMapResponses,
    GetProcessMiningMapErrors,
    ThrowOnError
  >({ url: "/process-mining/map", ...options });

/**
 * List Process Mining Variants
 *
 * Layer 2, the top variants: sequence, share, cumulative share, elapsed, re-work.
 *
 * A variant of fewer than 5 cases is not listed; its cases count in ``other_cases``.
 * ``level=process`` (M9, round 4): the context steps left out, repeats collapsed, each
 * path with a plain name.
 */
export const listProcessMiningVariants = <ThrowOnError extends boolean = false>(
  options?: Options<ListProcessMiningVariantsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListProcessMiningVariantsResponses,
    ListProcessMiningVariantsErrors,
    ThrowOnError
  >({ url: "/process-mining/variants", ...options });

/**
 * Get Process Mining Areas
 *
 * Layer 3, one global way? Each area against the global top variants and steps.
 */
export const getProcessMiningAreas = <ThrowOnError extends boolean = false>(
  options?: Options<GetProcessMiningAreasData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetProcessMiningAreasResponses,
    GetProcessMiningAreasErrors,
    ThrowOnError
  >({ url: "/process-mining/areas", ...options });

/**
 * Get Process Mining Tools
 *
 * Layer 4, the tools between the steps, from the by-hand imports of the current key.
 *
 * Presence of a tool in the active hours (never time in tool: "Not measured"), the
 * tools around a new quotation against a control window, the quotation mails, the
 * F&O form dwell (a lower bound) and the shared Excel files (the every-area rows
 * without an area filter, else the rows of the areas asked for). Every cell needs 5
 * people. Cached (round 4).
 */
export const getProcessMiningTools = <ThrowOnError extends boolean = false>(
  options?: Options<GetProcessMiningToolsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetProcessMiningToolsResponses,
    GetProcessMiningToolsErrors,
    ThrowOnError
  >({ url: "/process-mining/tools", ...options });

/**
 * List Process Mining Cases
 *
 * Layer 5, the case list: newest first, filtered by variant, activity or re-work.
 *
 * ``finding`` lists exactly the cases of an event-log finding: the detectors run again
 * on the cases of every area of the same window and kind (the all-area baselines need
 * them, review B2), then the area filter applies. A rule with no case list gives 422; a
 * finding that does not fire in the window gives ``total: 0``. Round 4: ``qtype``,
 * ``link_tier``, ``pain_point`` (the cases of the event-log findings of that pain
 * point), ``sort`` and ``q``; each row has its number, type, value, tier and pain points.
 */
export const listProcessMiningCases = <ThrowOnError extends boolean = false>(
  options?: Options<ListProcessMiningCasesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListProcessMiningCasesResponses,
    ListProcessMiningCasesErrors,
    ThrowOnError
  >({ url: "/process-mining/cases", ...options });

/**
 * Export Process Mining Cases
 *
 * The cases of the same filters as ``/process-mining/cases`` as a CSV file (round 4).
 *
 * The header row is the ``PmCaseRow`` fields; at most ``PM_CSV_MAX_ROWS`` rows. A cell
 * that starts with ``=``, ``+``, ``-`` or ``@`` gets a leading ``'`` (no formula). No
 * person, no address: the rows of the list only.
 */
export const exportProcessMiningCases = <ThrowOnError extends boolean = false>(
  options?: Options<ExportProcessMiningCasesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ExportProcessMiningCasesResponses,
    ExportProcessMiningCasesErrors,
    ThrowOnError
  >({ url: "/process-mining/case-export", ...options });

/**
 * Get Process Mining Case
 *
 * Layer 5, one case in time order; a person is "Sales person A", never a name.
 *
 * ``i2q_case_id`` is set only when the case is in one of the caller's areas.
 */
export const getProcessMiningCase = <ThrowOnError extends boolean = false>(
  options: Options<GetProcessMiningCaseData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProcessMiningCaseResponses,
    GetProcessMiningCaseErrors,
    ThrowOnError
  >({ url: "/process-mining/cases/{case_key}", ...options });

/**
 * Get Process Mining Baseline
 *
 * "Where I2Q helps": the measured baseline and the steps I2Q takes over.
 *
 * Touchless share (ASSUMED definition), F&O form dwell per quotation (lower bound),
 * work minutes per quotation ("Not measured"), corrections after release, the visible
 * reply share, the link share, the quotation mails seen, the median inquiry to
 * quotation; total and per area. Cached (round 4).
 */
export const getProcessMiningBaseline = <ThrowOnError extends boolean = false>(
  options?: Options<GetProcessMiningBaselineData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetProcessMiningBaselineResponses,
    GetProcessMiningBaselineErrors,
    ThrowOnError
  >({ url: "/process-mining/baseline", ...options });

/**
 * Get Process Mining Value
 *
 * The value of today's quoting and the I2Q baseline scorecard (round 4, 16 Oct 2026).
 *
 * Speed against orders (with the Mantel-Haenszel effect over area and size), where the
 * time goes, the first answer in working hours, the decisions within 30 days, the
 * ASSUMED follow-up upside, the benchmarks, the weekly series, the funnel, the parts of
 * the re-work, the scorecard and the headline. The pain points come from the cached
 * findings of the same filters. Every ASSUMED value comes back in ``assumptions``; the
 * targets are null until the steering group sets them. Cached.
 */
export const getProcessMiningValue = <ThrowOnError extends boolean = false>(
  options?: Options<GetProcessMiningValueData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetProcessMiningValueResponses,
    GetProcessMiningValueErrors,
    ThrowOnError
  >({ url: "/process-mining/value", ...options });

/**
 * Download Process Mining Report
 *
 * The process-mining report of one audience as a ``.docx`` or a ``.pptx`` file.
 *
 * Built from the stored default answers of the last build and the cached text of the
 * current story, else the standard text (header ``X-Report-Text``: ai, standard or mixed).
 * Never calls the model and never waits for it.
 */
export const downloadProcessMiningReport = <ThrowOnError extends boolean = false>(
  options: Options<DownloadProcessMiningReportData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    DownloadProcessMiningReportResponses,
    DownloadProcessMiningReportErrors,
    ThrowOnError
  >({ url: "/process-mining/report", ...options });

/**
 * Get Process Mining Report Status
 *
 * The text state of one report for the current build; reads only, never calls the model.
 */
export const getProcessMiningReportStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetProcessMiningReportStatusData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProcessMiningReportStatusResponses,
    GetProcessMiningReportStatusErrors,
    ThrowOnError
  >({ url: "/process-mining/report/status", ...options });

/**
 * Write Process Mining Report Texts
 *
 * Ask for the text of one report; the model call runs in the background.
 *
 * Claims the key of the current story (one writer over the replicas) and returns at once
 * with ``writing``, or returns the current state when the text exists or another writer
 * holds the claim. Metered as ``pm_report`` and capped by the guard ``pm_report``.
 */
export const writeProcessMiningReportTexts = <ThrowOnError extends boolean = false>(
  options: Options<WriteProcessMiningReportTextsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WriteProcessMiningReportTextsResponses,
    WriteProcessMiningReportTextsErrors,
    ThrowOnError
  >({
    url: "/process-mining/report/texts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Process Mining Runs
 *
 * The builds and the imports, with the key state ("Old key" rows count nowhere).
 */
export const listProcessMiningRuns = <ThrowOnError extends boolean = false>(
  options?: Options<ListProcessMiningRunsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListProcessMiningRunsResponses,
    ListProcessMiningRunsErrors,
    ThrowOnError
  >({ url: "/process-mining/runs", ...options });

/**
 * List Process Mining Anchors
 *
 * The quotations a person made, for the by-hand extraction: hash, area, time, pseudonym.
 *
 * Only ``sales_person`` rows with a pseudonym; no quotation number, no identity.
 */
export const listProcessMiningAnchors = <ThrowOnError extends boolean = false>(
  options: Options<ListProcessMiningAnchorsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListProcessMiningAnchorsResponses,
    ListProcessMiningAnchorsErrors,
    ThrowOnError
  >({ url: "/process-mining/anchors", ...options });

/**
 * Create Process Mining Import
 *
 * Write one batch of the by-hand Defender or F&O telemetry extraction.
 *
 * Pseudonymised aggregates only (the patterns of the models refuse anything else). A
 * new import replaces the rows of an older import of the same kind and key whose
 * window overlaps; ``import_id`` appends a later batch to the same import. Round 6
 * (two-phase, O6): ``final: false`` keeps the import open (no read sees it, it replaces
 * nothing); the batch with ``final: true`` replaces and completes it in one transaction.
 */
export const createProcessMiningImport = <ThrowOnError extends boolean = false>(
  options: Options<CreateProcessMiningImportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateProcessMiningImportResponses,
    CreateProcessMiningImportErrors,
    ThrowOnError
  >({
    url: "/process-mining/imports",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Platform Status
 *
 * What runs today: areas and mailboxes, shadow mode, switches, jobs, cost, version.
 *
 * Live from the system and from the sources other pages use (the Summary, "Cost and
 * runs", the data health): no figure is computed twice. No case id, no person, never who
 * switched a switch. Per-area visibility as ``GET /metrics/ops``: the areas, their
 * mailboxes, the inquiries and "Done without a person" cover only the caller's areas;
 * shadow mode, switches, jobs, cost, version and data health are platform facts and
 * stay global. Every signed-in person (the product owner, 15 Oct 2026), an
 * executive-only session too (listed in ``EXECUTIVE_ONLY_ROUTES``). Cached 5 minutes
 * per scope.
 */
export const getPlatformStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetPlatformStatusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetPlatformStatusResponses,
    GetPlatformStatusErrors,
    ThrowOnError
  >({ url: "/status/today", ...options });

/**
 * Auth Logout
 *
 * Sign out — clear the session cookie.
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    url: "/auth/logout",
    ...options,
  });

/**
 * Auth Me
 *
 * Return the current session's identity and the areas whose mail it may see.
 *
 * `areas` is `["all"]`, a list of area codes (`["dk", "fr"]`) or empty when the
 * account has no area assigned. `mailboxes` are the intake mailboxes behind those
 * areas, lower case (the default "my mailboxes" filter of the queue). `roles` are
 * the work roles of the account (`manager`, `admin`, `executive`) and `capabilities`
 * what they allow (`see_margin`, `see_exec_summary`, ...). An account whose only role
 * is `executive` reads the dashboard summary and the monthly report and gets a 403 on
 * the sales work. A role never changes `areas` or `mailboxes`.
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    url: "/auth/me",
    ...options,
  });
